module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./SortActivityView.js"));
	}, "SortActivityView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=SortActivityView!./src/pages/Shop/Home/SortActivity/SortActivityView.js
// module id = 1416
// module chunks = 418